import SectionMessage from '@atlaskit/section-message';
import Link from '@atlaskit/link';
import * as React from 'react';
export default {
  SectionMessage,
  Link,
  React
};